module.exports = __webpack_public_path__ + "img/helloquence-61189-unsplash.f560887e.jpg";